import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DashboardChoVay from './DashboardChoVay';
import DashboardLoinhuan from './DashboardLoinhuan';
import LoanContracts from './LoanContracts';
export default function Dashboard() {
  const [credit_total_cnt, setCredit_total_cnt] = useState(0);
  const [installment_total_cnt, setInstallment_total_cnt] = useState(0);
  const [credit_total_cnt_cur, setCredit_total_cnt_cur] = useState(0);
  const [installment_total_cnt_cur, setInstallment_total_cnt_cur] = useState(0);
  const [credit_total_loan, setCredit_total_loan] = useState(0);
  const [installment_total_loan, setInstallment_total_loan] = useState(0);
  const [credit_total_interest, setCredit_total_interest] = useState(0);
  const [installment_total_interest, setInstallment_total_interest] = useState(0);

  const fetchData = () => {
    const token = localStorage.getItem('token');

    fetch(`${process.env.REACT_APP_API_DB_URL}/data-dashboard`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(d => {

        //console.log(d)
        setCredit_total_cnt(d.credit_total_cnt)
        setInstallment_total_cnt(d.installment_total_cnt)
        setCredit_total_cnt_cur(d.credit_total_cnt_cur)
        setInstallment_total_cnt_cur(d.installment_total_cnt_cur)
        setCredit_total_loan(d.credit_total_loan)
        setInstallment_total_loan(d.installment_total_loan)
        setCredit_total_interest(d.credit_total_interest)
        setInstallment_total_interest(d.installment_total_interest)
      })
      .catch(error => {
        console.error('Lỗi khi lấy dữ liệu:', error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Stack direction="row" alignItems="center"  spacing={1} sx={{ width: '100%' }}>
        <LoanContracts curLoanCredit={credit_total_cnt_cur} totalLoanCredit={credit_total_cnt} curLoanInstallment={installment_total_cnt_cur} totalLoanInstallment={installment_total_cnt}/>
        <DashboardChoVay totalLoanCredit = {credit_total_loan} totalLoanInstallment={installment_total_loan}/>
        <DashboardLoinhuan totalLoanCredit={credit_total_interest} totalLoanInstallment={installment_total_interest}/>
        
    </Stack>
  );
}
